import { EEntities } from '@/types'
import Vue from 'vue'

export default Vue.extend({
  props: {
    entityType: {
      type: String as () => EEntities,
      required: true,
      validator: (value: string) => {
        const allowedEntities: String[] = Object.keys(EEntities).map(
          (k: any) => EEntities[k],
        )
        return allowedEntities.indexOf(value) !== -1
      },
    },
  },
})
